/**
 * @file Static blocker factory.
 *
 * Walls and obstacles carry no `Renderable`: their geometry is drawn by the
 * arena as batched/instanced meshes, so hundreds of blockers still cost a
 * handful of draw calls. The entity exists purely so the collision system can
 * treat them like anything else.
 */

import { Transform, Collider } from '../components/index.js';
import { Layer } from '../config/GameConfig.js';

/**
 * Creates an immovable box collider.
 *
 * @param {import('../core/Context.js').GameContext} ctx Shared game context.
 * @param {number} x Centre X.
 * @param {number} z Centre Z.
 * @param {number} halfX Half-extent along X.
 * @param {number} halfZ Half-extent along Z.
 * @param {string} [name] Debug label.
 * @returns {import('../ecs/Entity.js').Entity}
 */
export function createWall(ctx, x, z, halfX, halfZ, name = 'wall') {
  const entity = ctx.world.createEntity(name);

  entity.add(new Transform(x, 0, z));
  entity.add(
    new Collider({
      halfX,
      halfZ,
      layer: Layer.WALL,
      mask:
        Layer.PLAYER |
        Layer.ENEMY |
        Layer.PLAYER_BULLET |
        Layer.ENEMY_BULLET |
        Layer.THROWN_WEAPON,
      isStatic: true
    })
  );

  return entity;
}
